import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const Container = styled.div`
  position: absolute;
  top: 12.5%;
  left: 8.28125%;
  right: 8.28125%;
  width: 83.4375%;
`

export const Button = styled(Link)`
  float: left;
  width: 48.69%;
  transition: background-color 100ms;
  margin-bottom: 0.9vw;

  :nth-child(2n + 1) {
    margin-right: 2.62%;
  }

  :hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`
